import { render, staticRenderFns } from "./CmgOrderReviewModal.vue?vue&type=template&id=b5674f26&scoped=true&lang=pug"
import script from "./cmg-order-review-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-order-review-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgOrderReviewModal.vue?vue&type=style&index=0&id=b5674f26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5674f26",
  null
  
)

export default component.exports